import { useMutation, useQueryClient } from "@tanstack/react-query";
import { enqueueSnackbar } from "../../../components/GlobalSnackbar/snackbarStore";
import { useAuth } from "../../../hooks/useAuth";
import { apiClient } from "@copro/api";
import { keys } from "./keys";

async function archiveSubTopic(id: string, userId: string | undefined) {
  if (!userId) {
    throw new Error('Utilisateur non authentifié.')
  }

  const { error } = await apiClient
    .from('sub_topics')
    .update({
      archived_at: new Date().toISOString(),
      archived_by: userId,
      state: 'closed'
    })
    .eq('id', id)

  if (error) {
    throw error
  }
}

export function useArchiveSubTopic() {
  const { user } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (subTopicId: string) => archiveSubTopic(subTopicId, user?.id),
    onSuccess: () => {
      enqueueSnackbar('Sous-sujet archivé.', 'success');

      queryClient.invalidateQueries({ queryKey: keys.subTopicList() })
    }
  })
}
